<template>
<div>
    <bar-manut
        single-entity="Usuário"
        plural-entity="Usuários"
        :crud="this.crud"
        :btn-delete="!usuarioComumLogado && index != $store.getters.getSessao.codusuario && usuario.uuid !== $store.getters.getEnv.uuid"
        @closeform="closeForm"
        @delete="handleDelete"
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            <div class="row">
                <form-field ref="nome" v-model="usuario.nome" type="text" col="6" label="Nome"
                    name="nome" :v-errors="errors" v-validate="{required: true, max: 60}"></form-field>
            </div>
            <div class="row">
                <form-field v-model="usuario.email" type="email" col="6" label="Email" :disabled="usuarioComumLogado"
                    name="email" :v-errors="errors" v-validate="{required: true, max: 255, email: true}"></form-field>
            </div>
            <div class="row">
                <form-field v-model="usuario.fone" type="fone" col="3" label="Telefone"
                    name="fone" :v-errors="errors" v-validate="{max: 30}"></form-field>
            </div>
            <div class="row" v-if="!usuarioComumLogado">
                <div class="col mt-2 mb-5">
                    <input-checkbox v-model="usuario.stusuario" value-checked="A" value-unchecked="I" label="Usuário Ativo" :disabled="isView"></input-checkbox>
                </div>
            </div>
            <div v-if="alteraSenha">
                <label-title class="mb-2" title="Senha" icon=""></label-title>
                <div class="row">
                    <form-field v-model="senha1" type="password" col="4" label="Senha"
                        name="senha1" :v-errors="errors" v-validate="{required: true, max: 20}">
                        <span class="data-list w-100"><small>Defina a senha com no máximo 20 caracteres</small></span>
                    </form-field>
                </div>
                <div class="row">
                    <form-field v-model="senha2" type="password" col="4" label="Repetir Senha"
                        name="senha2" :v-errors="errors" v-validate="{required: true, max: 20}"></form-field>
                </div>
            </div>
            <div v-if="!editing">
                <label-title class="mb-2" title="Senha" icon=""></label-title>
                <alert type="warning" title="Definição de senha" text="O novo usuário receberá um email para definição da senha"></alert>
            </div>

            <div v-if="!usuarioComumLogado">
                <label-title class="mt-5" title="Selecione o Perfil de Usuário" icon=""></label-title>
                <div class="row" v-if="usuario.perfil == '0'">
                    <div class="col-md-6 col-6 nb-margin-top mb-2">
                        <div class="custom-control custom-radio">
                            <input type="radio" id="customRadio0" class="custom-control-input" value="0" v-model="usuario.perfil">
                            <label class="custom-control-label data-list" for="customRadio0">Usuário criador da conta</label>
                            <span class="data-list w-100">Trata-se do criador da conta e portanto possui acesso irrestrito à todas as funcionalidades do sistema</span>
                        </div>
                    </div>
                </div>
                <!-- HABILTA OS TIPOS DE USUÁRIO SOMENTE QUANDO O USUÁRIO EM EDIÇÃO NÃO FOR O CRIADOR DA CONTA -->
                <div class="row" v-if="usuario.perfil != '0'">
                    <div class="col-md-6 col-6 nb-margin-top mb-2">
                        <div class="custom-control custom-radio">
                            <input type="radio" id="customRadio1" class="custom-control-input" value="1" v-model="usuario.perfil">
                            <label class="custom-control-label data-list" for="customRadio1">Administrador do sistema</label>
                            <span class="data-list w-100">Possui acesso irrestrito à todas as funcionalidades do sistema</span>
                        </div>
                    </div>
                    <!-- <div class="col-md-6 col-6 nb-margin-top mb-2">
                        <div class="custom-control custom-radio">
                            <input type="radio" id="customRadio2" class="custom-control-input" value="2" v-model="usuario.perfil">
                            <label class="custom-control-label data-list" for="customRadio2">Gerente</label>
                            <span class="data-list w-100">Gerentes podem visualizar dados de outros usuários da mesma equipe quando a empresa optar por utilizar o cadastro de equipes para melhor organização dos colaboradoes</span>
                        </div>
                    </div> -->
                    <div class="col-md-6 col-6 nb-margin-top mb-2">
                        <div class="custom-control custom-radio">
                            <input type="radio" id="customRadio3" class="custom-control-input" value="4" v-model="usuario.perfil">
                            <label class="custom-control-label data-list" for="customRadio3">Usuário Normal</label>
                            <span class="data-list w-100">Trata-se de usuário comum com acesso restrito às funcionalidades de cadastros e movimentações do sistema</span>
                        </div>
                    </div>
                    <div class="col-md-6 col-6 nb-margin-top mb-2">
                        <div class="custom-control custom-radio">
                            <input type="radio" id="customRadio4" class="custom-control-input" value="3" v-model="usuario.perfil">
                            <label class="custom-control-label data-list" for="customRadio4">Representante ou Vendedor</label>
                            <span class="data-list w-100">Trata-se de representante comercial que utiliza o sistema somente para lançamento de pedidos sem acesso a nenhuma outra funcionalidade</span>
                        </div>
                    </div>
                    <div class="col-md-6 col-6 nb-margin-top mb-2">
                        <div class="custom-control custom-radio">
                            <input type="radio" id="customRadio5" class="custom-control-input" value="5" v-model="usuario.perfil">
                            <label class="custom-control-label data-list" for="customRadio5">Usuário PDV</label>
                            <span class="data-list w-100">Trata-se de usuário com acesso restrito às funcionalidades de Varejo</span>
                        </div>
                    </div>

                </div>
            </div>

            <div v-if="usuario.perfil != '0' && !usuarioComumLogado">
                <label-title class="mt-5" title="Permissões Para Pedidos" icon=""></label-title>
                <div class="row">
                    <div class="col-md-12 col-12 mt-2">
                        <input-checkbox :title="hBloqueiaTabela" v-model="parametros.vendas.bloqueia_tabela_cliente" :value-checked="true" :value-unchecked="false" label="Bloqueia alteração de tabela de preço quando o cliente informado já possuir tabela de preços vinculada em seu cadastro"></input-checkbox>
                    </div>
                    <div class="col-md-12 col-12 mt-2">
                        <input-checkbox :title="hBloqueiaPreco" v-model="parametros.vendas.bloqueia_preco_item" :value-checked="true" :value-unchecked="false" label="Bloqueia alteração no preço do produto"></input-checkbox>
                    </div>
                    <div class="col-md-12 col-12 mt-2">
                        <input-checkbox :title="hBloqueiaDescontos" v-model="parametros.vendas.bloqueia_descontos" :value-checked="true" :value-unchecked="false" label="Bloqueia descontos no pedido"></input-checkbox>
                    </div>
                    <div class="col-md-12 col-12 mt-2">
                        <input-checkbox :title="hBloqueiaGerarPedido" v-model="parametros.vendas.bloqueia_gerar_pedido" :value-checked="true" :value-unchecked="false" label="Bloqueia gerar pedido de orçamento"></input-checkbox>
                    </div>
                    <div class="col-md-12 col-12 mt-2">
                        <input-checkbox :title="hBloqueiaAlterarPedido" v-model="parametros.vendas.bloqueia_alterar_pedido" :value-checked="true" :value-unchecked="false" label="Bloqueia alterar pedido"></input-checkbox>
                    </div>
                    <div class="col-md-12 col-12 mt-2">
                       <v-label label="Informe o desconto máximo permitido na venda"></v-label>
                    </div>
                    <form-field v-model="parametros.vendas.desconto_maximo" type="value" addon="%" col="2" :precision="2"></form-field>
                </div>
                <label-title class="mt-5" title="Tabelas de preços" icon=""></label-title>
                <div class="row col">
                    <v-label label="Selecione as tabelas de preços que serão liberadas para este usuário"></v-label>
                </div>
                <div class="border p-3">
                    <div class="row">
                        <div class="col-md-6 col-12" v-for="(tabela, index) in tabelaspreco" v-bind:key="index">
                            <input-switch type="success" :label="tabela.descricao" v-model="tabela.liberada" :value-checked="true" :value-unchecked="false"></input-switch>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDSapp, apiORDSdelete2, apiValidaLimitePlano } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            // usuario: {...this.$store.getters.getEntities.usuario},
            // metadata: this.$store.getters.getEntities.metadata,
            senha1: '',
            senha2: '',
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela

            hBloqueiaAlterarPedido: 'Bloqueia alterar pedido',
            hBloqueiaGerarPedido: 'Bloqueia gerar pedido de orçamento',
            hBloqueiaDescontos: 'Bloqueia acesso aos campos de descontos do pedido para este usuário',
            hBloqueiaPreco: 'Bloqueia o acesso ao campo de preço do produto para este usuário',
            hBloqueiaTabela: 'Bloqueia o acesso ao campo de tabela de preços quando o cliente informado já possuir tabela de preços vinculada em seu cadastro',

            metadata: {usuario: {
                codusuario: { label: 'Código', fieldname: 'codusuario' },
                nome: { label: 'Nome do Usuário', fieldname: 'nome' },
                email: { label: 'Email Para Login', fieldname: 'email' },
                senha: { label: 'Senha', fieldname: 'senha' },
                stusuario: {
                    label: 'Situação',
                    fieldname: 'stusuario',
                    options: [{id: 'A', text: 'Ativo'}, {id: 'I', text: 'Inativo'}]
                    },
                }
            },

            usuario: {
                codusuario: null,
                nome: '',
                email: '',
                senha: '',
                stusuario: '',
                perfil: '',
            },

            parametros: {
                vendas: {
                    tabelaspreco: [],
                    desconto_maximo: 0,
                    bloqueia_tabela_cliente: false,
                    bloqueia_preco_item: false,
                    bloqueia_descontos: false,
                    bloqueia_gerar_pedido: false,
                    bloqueia_alterar_pedido: false,
                }
            },

            tabelaspreco: null,

        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        },

        alteraSenha: function () {
            return this.editing && !this.usuarioComumLogado || this.usuario.uuid === this.$store.getters.getEnv.uuid
        },

        tabpreList: function () {
            return this.$store.getters.getTabpreList
        },

        usuarioComumLogado: function () {
            return this.$store.getters.getSessao.perfil > '1'
        },

    },

    watch: {

    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        handleSave () {
            if (this.senha1 != this.senha2) {
                alert('As senhas não conferem')
                return
            }

            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })

        },

        handleDelete () {
            //BOTAO EXCLUIR
            this.apiDelete()
        },

        async apiDelete () {
            //EFETUA A EXCLUSAO DO USUARIO
            var url = this.$store.getters.urlApp + 'usuario/' + this.usuario.codusuario
            const data = await apiORDSdelete2(url)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async loadData () {
            if (!this.tabelaspreco) {
                await this.$store.dispatch('loadTabpre', {})
                this.tabelaspreco = [...this.tabpreList]
                for (var x = 0; x < this.tabelaspreco.length; x++) {
                    this.$set(this.tabelaspreco[x], 'liberada', false)
                }
            }

            if (!this.index)
              return

            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadUsuario', { id: this.index } )
            if (this.$store.getters.getUsuario) {
                this.usuario = {...this.$store.getters.getUsuario}
                this.senha1 = this.usuario.senha
                this.senha2 = this.usuario.senha
            }
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })


            //carrega os parametros do usuario
            if (this.usuario.parametros) {
                this.parametros = JSON.parse(this.usuario.parametros)
            } else {
                this.parametros = {
                    vendas: {
                        desconto_maximo: null,
                        tabelaspreco: [],
                        bloqueia_tabela_cliente: false,
                        bloqueia_preco_item: false,
                        bloqueia_descontos: false,
                        bloqueia_gerar_pedido: false,
                        bloqueia_alterar_pedido: false,
                    }
                }
            }

            if (!this.parametros.vendas)
              this.parametros.vendas = {
                        desconto_maximo: null,
                        tabelaspreco: [],
                        bloqueia_tabela_cliente: false,
                        bloqueia_preco_item: false,
                        bloqueia_descontos: false,
                        bloqueia_gerar_pedido: false,
                        bloqueia_alterar_pedido: false,
              }

            if (!this.parametros.vendas.bloqueia_tabela_cliente)
              this.parametros.vendas.bloqueia_tabela_cliente = false

            if (!this.parametros.vendas.bloqueia_preco_item)
              this.parametros.vendas.bloqueia_preco_item = false

            if (!this.parametros.vendas.bloqueia_descontos)
              this.parametros.vendas.bloqueia_descontos = false

            if (!this.parametros.vendas.bloqueia_gerar_pedido)
              this.parametros.vendas.bloqueia_gerar_pedido = false

            if (!this.parametros.vendas.bloqueia_alterar_pedido)
              this.parametros.vendas.bloqueia_alterar_pedido = false

            //marca as tabelas liberadas
            let testTabela = null
            for (var x = 0; x < this.tabelaspreco.length; x++) {
                testTabela = this.parametros.vendas.tabelaspreco.filter(obj => obj == this.tabelaspreco[x].codtabpre)
                this.tabelaspreco[x].liberada = testTabela.length > 0
            }

        },

        async loadTabpre () {

        },

        async apiPost () {
            //efetua a gravacao

            //validacao para inclusao de novo usuário
            if (this.lCrud == SysVars.crudI) {
                let isValid = true
                if (this.usuario.perfil == '3')
                    isValid = await apiValidaLimitePlano(this, 'representantes')
                else
                    isValid = await apiValidaLimitePlano(this, 'usuarios')
                if (!isValid)
                    return
            }

            var sendData = {}

            this.usuario.parametros = null

            if (this.usuario.perfil != '0') {
                this.parametros.vendas.tabelaspreco = []

                for (let x = 0; x < this.tabelaspreco.length; x++) {
                    if (this.tabelaspreco[x].liberada)
                    this.parametros.vendas.tabelaspreco.push(this.tabelaspreco[x].codtabpre)
                }
                this.usuario.parametros = this.parametros
            }

            this.usuario.senha = this.senha1
            sendData = { usuario: this.usuario }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSapp(this, 'usuario/', metodo, sendData)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },

    },

    components: {

    },

    beforeCreate () {

    },

    async mounted () {
        this.$nextTick(function () {
            this.$refs.nome.focus()
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    },

    created () {

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
            this.usuario.stusuario = 'A'
            this.usuario.perfil = '1'
        } else {

        }
        this.loadData()

        this.$scrollTo(0)

    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/usuario-form.vue